const storeName = 'CORE';
export default {
    ADD_SAGA: `${storeName}.ADD_SAGA`,
    REMOVE_SAGA: `${storeName}.REMOVE_SAGA`,
    ADD_REDUCER: `${storeName}.ADD_REDUCER`,
    REMOVE_REDUCER: `${storeName}.REMOVE_REDUCER`,
    AFTER_ADD_REDUCER: `${storeName}.AFTER_ADD_REDUCER`,
};
